import { User } from '../apis/types'
import { USER_STORE_CONSTANTS } from '../constants/constants'

const EXPECTED_PARTS = 3 // JWT has 3 parts

function validateAccessToken(token: string): boolean {
  if (!token) return false

  const parts = token.split('.')

  if (parts.length !== EXPECTED_PARTS) {
    return token.length > 10
  }

  try {
    const payload = JSON.parse(atob(parts[1]))
    const now = Math.floor(Date.now() / 1000)

    return payload.exp >= now
  } catch (e) {
    console.error('error message:', e)
    return false
  }
}

function getUserIdFromToken(token: string): string {
  const payload = JSON.parse(atob(token.split('.')[0]))
  return payload.sub
}

function setExpiryTimestamp(user: User): User {
  const payload = { ...user }
  if (payload.expiresIn && payload.expiresIn > 0) {
    if (payload.expiresIn < USER_STORE_CONSTANTS.TIMESTAMP_MINIMUM_NUMBER) {
      payload.expiresIn = Date.now() + payload.expiresIn * 1000
    }
  }
  return payload
}

export { validateAccessToken, getUserIdFromToken, setExpiryTimestamp }
